export default [
    { id: 0, title: 'Em processo por ADM', backgroundColor: ['rgb(78,119,175)']},
    { id: 1, title: 'Em processo por ESCOPO', backgroundColor: ['rgb(106,223,72)']},
    { id: 2, title: 'Ativo por ESCOPO', backgroundColor: ['#ffcc2c']},
    { id: 3, title: 'Suspenso por ESCOPO', backgroundColor: ['#ff0c31']},
    { id: 4, title: 'Cancelados por ESCOPO', backgroundColor: ['rgb(151,204,239)']},
]
